const getImages = ({ config }) => {
    const { assets } = config.hosts;
    return {
        success: `${assets}assets/account-services/cli_success.svg`,
        error: `${assets}assets/account-services/technical_error_cat.svg`,
        ladyWarning: `${assets}assets/account-services/lady-warning.svg`,
        ladySuccess: `${assets}assets/account-services/cli_success.svg`,
        addAuthorizedUser: `${assets}assets/account-services/manage_cardholders.svg`
    };
};
export default getImages;
